import { createContext, useContext } from 'react';
import { SearchFilters, OfferSearchResult } from '../../features/search/types/search.types';

export interface MapViewport {
  center: [number, number];
  zoom: number;
}

export interface SearchContextState {
  filters: SearchFilters | null;
  results: OfferSearchResult[];
  scrollPosition: number;
  totalResults: number;
  viewMode: 'list' | 'map';
  mapViewport: MapViewport | null;
}

export interface SearchContextValue {
  searchContext: SearchContextState;
  setSearchContext: (
    filters: SearchFilters,
    results: OfferSearchResult[],
    totalResults: number
  ) => void;
  setScrollPosition: (position: number) => void;
  setViewMode: (mode: 'list' | 'map') => void;
  setMapViewport: (viewport: MapViewport | null) => void;
  clearSearchContext: () => void;
  getSearchContext: () => SearchContextState;
  /** Patch the isFavorite flag for a single offer in the cached results. */
  updateFavoriteInResults: (offerId: string, isFavorite: boolean) => void;
}

export const SearchContext = createContext<SearchContextValue | undefined>(undefined);

export function useSearchContext() {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearchContext must be used within a SearchContextProvider');
  }
  return context;
}
